module.exports = __webpack_public_path__ + "static/media/67-cayman.2cb8924d.JPG";